import React, { useState } from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { ArrowRight } from "lucide-react";
import PageBanner from "../components/PageBanner";
import { allProjects, projectCategories } from "../data/projectsData";

const ProjectsPage = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.05 });
  const [activeCategory, setActiveCategory] = useState("All");

  const filtered = activeCategory === "All"
    ? allProjects
    : allProjects.filter(p => p.category === activeCategory);

  return (
    <>
      <PageBanner
        title="Our Projects"
        subtitle="3D Printing Portfolio & Case Studies"
        image="https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=1920&h=600&fit=crop"
        breadcrumbs={[{ label: "Projects" }]}
      />

      <section className="inner-section" ref={ref}>
        <div className="inner-container">
          <motion.div initial={{ opacity: 0, y: 30 }} animate={inView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.6 }}>
            <span className="section-subtitle">Portfolio</span>
            <h2 className="section-title">3D Printing Projects Gallery</h2>
            <div className="section-line" />
            <p className="section-intro-text">
              From medical devices to architectural scale models, each project showcases 3D Printzkart's
              diverse additive manufacturing capabilities. Browse by category to explore our work.
            </p>
          </motion.div>

          {/* Filters */}
          <div className="project-filters">
            {projectCategories.map(cat => (
              <button key={cat}
                className={`filter-btn ${activeCategory === cat ? 'active' : ''}`}
                onClick={() => setActiveCategory(cat)}>{cat}</button>
            ))}
          </div>

          {/* Grid */}
          <div className="projects-page-grid">
            {filtered.map((project, i) => (
              <motion.div key={project.id} className="project-page-card"
                initial={{ opacity: 0, y: 20 }}
                animate={inView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.4, delay: Math.min(i * 0.06, 0.5) }}
                layout>
                <div className="ppc-image" style={{ paddingTop: '100%', position: 'relative', overflow: 'hidden' }}>
                  <img 
                    src={project.image} 
                    alt={project.title} 
                    loading="lazy" 
                    style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover' }}
                  />
                  <div className="ppc-overlay">
                    <span className="ppc-category">{project.category}</span>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

          {filtered.length === 0 && (
            <p style={{ textAlign: 'center', padding: '40px 0', color: '#666' }}>
              No projects found in this category. Try selecting a different filter.
            </p>
          )}
        </div>
      </section>

      <section className="cta-section">
        <div className="cta-inner">
          <h2 className="cta-title">Have a Similar Project in Mind?</h2>
          <p className="cta-desc">Share your requirements and our team will provide a detailed quote with technology recommendations.</p>
          <a href="/contact" className="btn-primary">Start Your Project <ArrowRight size={18} /></a>
        </div>
      </section>
    </>
  );
};

export default ProjectsPage;
